import React from 'react'
import { Typography, Button, CircularProgress, Tooltip } from '@mui/material'
import PublicIcon from '@mui/icons-material/Public'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { userSlice } from '../../../reducers'
import { useSelector } from 'react-redux'
import { googleTranslateLanguages } from '../../../reducers/content/languages'
import { useTranslation } from '../../../hooks'

export const getLanguageLabelByCode = (code) => {
  const language = googleTranslateLanguages.find((language) => language.value === code)
  return language ? language.translatedLabel : 'English'
}

export const SkillBiteTranslateButton = ({ loading, label, onClick }) => {
  const skillBiteLanguage = useSelector(userSlice.selectors.selectSkillBiteLanguage)
  const isProfileUpdating = useSelector(userSlice.selectors.selectIsProfileUpdating)
  const isLoading = loading || isProfileUpdating
  const { t } = useTranslation('skill_bite')

  return (
    <Tooltip title={t('change_language')}>
      <Button
        variant='text'
        disabled={isLoading}
        data-test='skill-bite-change-language-btn'
        startIcon={isLoading ? (<CircularProgress size={18} color='inherit' />) : (<PublicIcon color='action' />)}
        endIcon={<ArrowDropDownIcon color='action' />}
        onClick={onClick}
      >
        <Typography>{getLanguageLabelByCode(skillBiteLanguage)}</Typography>
      </Button>
    </Tooltip>
  )
}
